module.exports = __webpack_public_path__ + "img/select.e1a5faac.svg";